module.exports = __webpack_public_path__ + "static/media/phone.7d0049a2.svg";